import * as Yup from 'yup';

import { MAX_FEATURE_NAME_LENGTH, MIN_LENGTH } from '@hero/constants';

export const automationCreationSchema = Yup.object({
  name: Yup.string().min(MIN_LENGTH).max(MAX_FEATURE_NAME_LENGTH).required(),
  type: Yup.string().required()
});

export const automationReactivateSchema = Yup.object({
  redemptionWindow: Yup.number().required(),
  occasionScheduleDuration: Yup.number().required()
});

export const automationRemoveTagSchema = Yup.object({
  confirm: Yup.string()
    .matches(/^REMOVE TAG$/)
    .required()
});

export const deleteAllGiftWrapperSchema = Yup.object({
  confirm: Yup.string()
    .matches(/^DELETE WRAPPERS$/)
    .required()
});

export const getNameSchema = () =>
  Yup.object({
    name: Yup.string().min(MIN_LENGTH).max(MAX_FEATURE_NAME_LENGTH).required()
  });

export const removeOrderSchema = Yup.object({
  confirm: Yup.string()
    .matches(/^REMOVE ORDER$/)
    .required()
});

export const removeRecipientSchema = Yup.object({
  confirm: Yup.string()
    .matches(/^REMOVE RECIPIENT$/)
    .required()
});

export const removeRecipientsSchema = Yup.object({
  confirm: Yup.string()
    .matches(/^REMOVE RECIPIENTS$/)
    .required()
});
